import "./profile-briefs.scss";

import { Text, Icon, Link } from "@ui-kit";
import BriefItem from "./briefItem";
import OpportunItem from "./oppItem";
import countries from "../../../widgets/countriesDropDown/countries.json";
import { countriesWithIcons } from '../../../widgets/countriesDropDown/countriesIFasade.js';
import LinkIcon from '@ui-kit/icons/external-link-white.svg';

const ProfileBriefs = ({ briefs = [] }) => {

  return (
    <>
      <div className="briefs__header">
        <Text as="h1" className="title mb-4">
          My briefs
        </Text>
        <Text as="h5" className="sub-title">
          All briefs and inspirations ever uploaded by our users are stored
          here. Check the update date. Follow the links using the proxy/VPN of
          the country you selected the task from.
        </Text>
        <Link 
          size="sm" 
          icon={LinkIcon}
          to={'https://canva.com/creators/inspiration'}
          target="_blank"
        >
          <Text as="span">Go to Inspirations</Text>
        </Link>
      </div>
      <div className="briefs__container">
        {briefs?.map((countryItem, index) => {
          const country = countryItem?.country;
          const countryData = countries?.find(c => c.name === country);
          const foundCountry = countriesWithIcons?.find(c => c?.code === countryData?.code);
          const countryIcon = foundCountry?.icon ? foundCountry.icon : null

          return (
            <div className="briefs__country" key={`country-${index}`}>
              <div className="briefs__country-header">
                <Text as="h2" className="country-title">
                  <Icon src={countryIcon} className="flag" /> 
                  {country}
                </Text>
                <Text as="h5" className="update-date">
                  Last update:{" "}
                  {countryItem?.updatedAt}
                </Text>
              </div>
              <div className="briefs__country-briefs">
                <div className="briefs__country-briefs-header">
                  <Text as="h3" className="section-title">
                    Active Briefs
                  </Text>
                </div>
                {countryItem?.briefs?.map((brief, index) => {
                  return <BriefItem key={`brief-${index}`} item={brief} />;
                })}
              </div>
              <div className="opp-table">
                
                  <Text as="h3" className="section-title">
                    Opportunities
                  </Text>
          
                <div className="opp-table-header">
                  <div className="rank">
                    <Text as="h5">Rank</Text> 
                  </div>
                  <div className="title">
                    <Text as="h5">Title</Text>
                  </div>
                  <div className="description">
                    <Text as="h5">Description</Text>
                  </div>
                  <div className="create">
                    <Text as="h5">Create</Text>
                  </div>
                </div>
                <div className="opp-table-body">
                  {countryItem?.opportunities?.map((opp, index) => {
                    return <OpportunItem key={`opp-${index}`} item={opp} />;
                  })}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default ProfileBriefs;
